import {
  Box,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { NoticeData } from '../../../../../api/theHive/notices/types';
import { IconSwapVertMS } from '../../../../../constants/icons';
import { convertDate } from '../../../../../helpers';
import {
  StyledBox,
  StyledCell,
  StyledPagination,
  StyledRow,
  TableCellHeader,
} from './styles';

interface NoticesTableProps {
  tableData: NoticeData[];
  page: number;
  setPage: (value: number) => void;
  totalPages: number;
  kind: 'name' | 'announcement_date';
  setKind: (value: 'name' | 'announcement_date') => void;
  applyOrder: () => void;
}

export function NoticesTable({
  tableData,
  page,
  setPage,
  totalPages,
  kind,
  setKind,
  applyOrder,
}: NoticesTableProps): JSX.Element {
  const navigate = useNavigate();

  const handleNavigate = (companyId: number): void => {
    navigate(`./${companyId}`);
  };

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ): void => {
    setPage(value);
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCellHeader sx={{ paddingLeft: '10px' }}>
                <StyledBox
                  onClick={() => {
                    setKind('name');
                    if (kind === 'name') applyOrder();
                  }}
                >
                  {IconSwapVertMS}nome
                </StyledBox>
              </TableCellHeader>
              <TableCellHeader sx={{ paddingLeft: '10px' }}>
                <StyledBox
                  onClick={() => {
                    setKind('announcement_date');
                    if (kind === 'announcement_date') applyOrder();
                  }}
                >
                  {IconSwapVertMS}anúncio do edital
                </StyledBox>
              </TableCellHeader>
              <TableCellHeader>grupo de tipologias</TableCellHeader>
              <TableCellHeader>observação</TableCellHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.map((data) => (
              <StyledRow key={data.id} onClick={() => handleNavigate(data.id)}>
                <StyledCell>
                  <Tooltip title={data.name}>
                    <Box>
                      {data.name.length > 40
                        ? `${data.name.slice(0, 30)}…`
                        : data.name}
                    </Box>
                  </Tooltip>
                </StyledCell>
                <StyledCell>{convertDate(data.announcement_date)}</StyledCell>
                <StyledCell>
                  <Tooltip
                    title={
                      data.typology_groups
                        .map((item) => item.name)
                        .join(', ') || ''
                    }
                  >
                    <Box>
                      {data.typology_groups.length
                        ? data.typology_groups
                            .slice(0, 3)
                            .map((item) => item.name)
                            .join(', ')
                            .concat(
                              data.typology_groups.length > 3 ? '...' : ''
                            )
                        : '-'}
                    </Box>
                  </Tooltip>
                </StyledCell>
                <StyledCell>
                  <Tooltip title={data.observations}>
                    <Box>
                      {data.observations.length > 40
                        ? `${data.observations.slice(0, 40)}…`
                        : data.observations}
                    </Box>
                  </Tooltip>
                </StyledCell>
              </StyledRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <StyledPagination
        page={page}
        count={totalPages}
        onChange={handlePageChange}
      />
    </>
  );
}
